import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { UploadOutlined, IdcardOutlined } from "@ant-design/icons";
// import FaceIcon from "@mui/icons-material/Face";
import { Button } from "antd";
import { Link } from 'react-router-dom';

const documentsVeification = () => {
  return (
    <div className="main-verification main-verify-documents-now">
      <div className="main-verify-documents-now">
        <div className=" title documents-title"> Verify Profile in 3 Important Documents </div>

        <div className="documents d-flex h-100 justify-content-center text-center align-items-center">
          <Row>
            <Col md={4} className="text-center">
              <UploadOutlined className="icon" />
              <div className="document-title">Driving Licence</div>
              <div className="detail">Upload Driving Licence</div>
            </Col>
            <Col md={4} className="text-center">
              <IdcardOutlined className="icon" />
              <div className="document-title">Aadhar/Passport</div>
              <div className="detail">
                Upload Adhar card / Voter Id / Passport
              </div>
            </Col>
            <Col md={4} className="text-center">
              <IdcardOutlined className="icon" />
              <div className="document-title">Picture</div>
              <div className="detail">Upload your photo</div>
            </Col>
          </Row>
        </div>

        <Row>
          <Col>
            <div className=" verify-btn  d-flex flex-column justify-content-center align-items-center text-center ">
              <p>
                By continuing, you agree to applocable <span>T&Cs</span>{" "}
              </p>
                 <Link to="/documentupload">
                 <Button type="primary " className="button">
                Verify Profile Now
              </Button>
                 </Link>
            
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default documentsVeification;
